import { MAIN_BETS, } from './betTypes';

export const HANDS = {
  WINNING: 'Winning',
  BURN: 'Burn',
  ...MAIN_BETS,
};

export const INITIAL_STATE = {};
